<template>
    <div class="m-panel">
        <div class="m-panel-bar">
            <div class="m-panel-bar-title">
            {{title}}
            </div>
        </div>
        <div class="m-panel-body">
            <Echart ref="option" :options="option" style="height: 100%"></Echart>
        </div>
    </div>
</template>
<script>
import echarts from 'echarts/lib/echarts';
import { getAction } from '@/api/manage'
export default {
    props: {
            titleImage: {
            type: String,
            default: ''
        },
    },
    data() {
        return{
            title: this.$t('水质指标分析'),
            option: {},
            url: {
                queryWaterQualityIndexAnalysis: '/jeecg-charge/part/partWaterQualityLastRecord/queryWaterQualityIndexAnalysis'
            },
            dataSource: {}
        }
    },
    mounted() {
    },
    methods: {
        init() {
            this.resetData()
            this.queryWaterQualityIndexAnalysis()
        },
        resetData() {
            if(JSON.stringify(this.option) !== '{}'){
                this.$refs.option.clear();
            }
        },
        queryWaterQualityIndexAnalysis() {
            
            var params = {};
            getAction(this.url.queryWaterQualityIndexAnalysis, params).then((res) => {
            if (res.success) {
                this.dataSource = res.result;
                this.setOption();
            }
            if(res.code===510){
                this.$message.warning(res.message)
            }
            })
        },
        setOption() {
            let seriesData = []
            let data = [[],[]]
            let nameObj = {'w01001-Rtd':this.$t('PH值'),'w01002-Rtd':this.$t('色度'), 'w01003-Rtd':this.$t('浑浊度'),'w01006-Rtd':this.$t('溶解性总固体'),
                'w01014-Rtd': this.$t('电导率'),'w01010-Rtd': this.$t('水温'), 'w01019-Rtd': this.$t('高锰酸盐'),
                'w10000-Rtd':this.$t('硬度'),'w10001-Rtd':'ORP','w21022-Rtd':this.$t('氯化物'),'w21024-Rtd':this.$t('余氯'),'w21038-Rtd':this.$t('硫酸盐')};
            let category = []
            for(let i = 0;i<this.dataSource.nameList.length;i++) {
                if(this.dataSource.nameList[i] in nameObj) {
                    category.push(nameObj[this.dataSource.nameList[i]]);
                    data[0].push(this.dataSource.normalList[i]);
                    data[1].push(this.dataSource.warnList[i]);
                }
                
            }
            this.option = {
                color: ['#0276FF','#FECA20'],
                tooltip: {
                    trigger: 'axis',
                    formatter: '{b}<br />{a0}: {c0}<br />{a1}: {c1}',
                    backgroundColor: 'rgba(0,11,42,0.9)',
                    borderColor: '#5D6A94',
                    borderWidth: 1,
                    borderRadius: 8,
                    textStyle: {
                        color: '#CEE2FF',
                    },
                    axisPointer: {
                        type: 'line',
                        lineStyle: {
                            color: '#019AF3'
                        }
                    }
                },
                legend: {//图例组件，颜色和名字
                    itemGap: 16,
                    icon: "circle",
                    left: 'right',
                    itemHeight: 10,
                    data:[{
                        name:this.$t('正常'),
                    },
                    {
                        name:this.$t('异常'),
                    }],
                    textStyle: {
                        color: '#D1F3FF',
                        fontStyle: 'normal',
                        fontFamily: '微软雅黑',
                        fontSize: 12,            
                    }
                },
                xAxis: [
                    {
                        type: 'category',
                    //	boundaryGap: true,//坐标轴两边留白
                        data: category,
                        axisLabel: { //坐标轴刻度标签的相关设置。
                            //interval: 0,//设置为 1，表示『隔一个标签显示一个标签』
                            //	margin:15,
                            textStyle: {
                                color: '#CEE2FF',
                                fontStyle: 'normal',
                                fontFamily: '微软雅黑',
                                fontSize: 12,
                            }
                        },
                        axisTick:{//坐标轴刻度相关设置。
                            show: false,
                        },
                        axisLine:{//坐标轴轴线相关设置
                            show: true,
                            lineStyle: {
                                color:'#074671',
                            }
                        },
                        splitLine: { //坐标轴在 grid 区域中的分隔线。
                            show: false,
                        }
                    }
                ],
                yAxis: [
                    {
                        type: 'value',
                        splitNumber: 5,
                        axisLabel: {
                            textStyle: {
                                color: '#D1F3FF',
                                fontStyle: 'normal',
                                fontFamily: '微软雅黑',
                                fontSize: 12,
                            }
                        },
                        axisLine:{
                            show: false
                        },
                        axisTick:{
                            show: false
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                type: 'dotted',
                                color: ['#074671'],
                            }
                        }

                    }
                ],
                series : [
                    {
                        name:this.$t('正常'),
                        type:'bar',
                        data:data[0],
                        barWidth: 10,
                        barGap:0,//柱间距离
                        animationDelay: 100,
                        animationDuration: 3000,
                        itemStyle: {
                            normal: {
                                show: true,
                                borderWidth: 0,
                            }
                        },
                    },
                    {
                        name:this.$t('异常'),
                        type:'bar',
                        data:data[1],
                        barWidth: 10,
                        barGap:0,//柱间距离
                        animationDelay: 100,
                        animationDuration: 2000,
                        itemStyle: {
                            normal: {
                                show: true,
                                borderWidth: 0,
                            }
                        },
                    }
                ]
            };
        }
    }
}
</script>